import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SchedulingAssistant" */ './lazyIndex')
);

export const lazyInitializeSchedulingAssistant = new LazyAction(
    lazyModule,
    m => m.initializeSchedulingAssistant
);
export const lazyResetSchedulingAssistant = new LazyAction(
    lazyModule,
    m => m.resetSchedulingAssistant
);
export const lazyToggleShowWorkingHoursOnly = new LazyAction(
    lazyModule,
    m => m.toggleShowWorkingHoursOnly
);

export const SchedulingAssistant = createLazyComponent(lazyModule, m => m.SchedulingAssistant);
export { default as getSchedulingAssistantIsDirty } from './selectors/getIsDirty';
export { shouldShowWorkingHours } from './selectors/shouldShowWorkingHours';

export { isSchedulingAssistantEnabled } from './utils/isSchedulingAssistantEnabled';
export { default as saveSchedulingAssistantChanges } from './utils/saveSchedulingAssistantChanges';

export type { default as CalendarEventData } from './store/schema/CalendarEventData';
